import VitalSignTimeLineCard from "./VitalSignTimeLineCard";

export default VitalSignTimeLineCard;
